export function useChat() {
	const page = usePageStore().page ?? {};
	const route = useRoute();
	const config = useNuxtApp().$config.public;
	const isTest = useIsTest();

	const disableChatPaths = ["/tv-internett/tv/innholdsvelger/"];

	const disableChat = computed(() => {
		const isDisabledByMeta = page?.metadata?.disableChat;
		const isDisabledByConfig = config.disableChat;
		const isDisabledByTemplate = page?.template?.ref === "tweBoxWebApp";
		const isDisabledByPath = disableChatPaths.some((path) => route.fullPath.includes(path));

		return Boolean(isDisabledByMeta || isDisabledByConfig || isDisabledByTemplate || isDisabledByPath);
	});

	if (!disableChat.value) {
		useScript({
			src: isTest ? "https://chat-client.web.test.apc.telenor.net/client.js" : "https://chat.telenor.no/client.js",
			crossorigin: false,
			referrerpolicy: false,
		});
	}

	return { disableChat };
}
